/* Castello shared engine — motion (reveal/parallax/carousel/hover-src/pause) + quick-view.
   Loaded once (guarded); scopes are sections marked [data-castello].
   Editor-safe: re-inits on shopify:section:load, aborts all listeners on unload. */
(function () {
  'use strict';
  if (window.__castelloEngine) return;
  window.__castelloEngine = true;

  var scopes = new WeakMap(); // root element -> AbortController
  var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobileMQ = window.matchMedia('(max-width: 749px)');

  function esc(x) { var d = document.createElement('div'); d.textContent = x == null ? '' : x; return d.innerHTML; }

  function moneyFactory(fmt) {
    fmt = (fmt || '').replace(/<[^>]*>/g, '');
    return function (cents) {
      var a = cents / 100;
      function n(d) { return a.toFixed(d).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
      if (!fmt) return n(2);
      return fmt.replace(/\{\{\s*amount\s*\}\}/g, n(2))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, n(0))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, a.toFixed(2).replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, a.toFixed(0));
    };
  }

  /* ---------- reveal ---------- */
  function initReveal(root) {
    var targets = [];
    if (root.hasAttribute('data-cm-reveal')) targets.push(root);
    root.querySelectorAll('[data-cm-reveal]').forEach(function (t) { targets.push(t); });
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) { targets.forEach(function (t) { t.classList.add('is-in'); }); return; }
    targets.forEach(function (t) {
      var th = parseFloat(t.getAttribute('data-cm-threshold')) || 0.12;
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.disconnect(); } });
      }, { threshold: th });
      io.observe(t);
    });
  }

  /* ---------- carousel (arrows + progress) ---------- */
  function initCarousel(root, signal) {
    var track = root.querySelector('[data-cm-track]');
    if (!track) return;
    var prevBtn = root.querySelector('[data-cm-prev]');
    var nextBtn = root.querySelector('[data-cm-next]');
    var bar = root.querySelector('[data-cm-progress] .bar, [data-cm-progress]>span');
    var minW = parseFloat(root.getAttribute('data-cm-progress-min')) || 10;
    function stepSize() {
      var card = track.firstElementChild;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap || '20') || 20;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    }
    [prevBtn, nextBtn].forEach(function (btn) {
      if (!btn) return;
      btn.addEventListener('click', function () {
        track.scrollBy({ left: btn === nextBtn ? stepSize() : -stepSize(), behavior: 'smooth' });
      }, { signal: signal });
    });
    function updateUI() {
      var max = track.scrollWidth - track.clientWidth;
      var x = track.scrollLeft;
      if (prevBtn) prevBtn.disabled = x <= 2;
      if (nextBtn) nextBtn.disabled = x >= max - 2;
      if (bar && max > 0) {
        var w = Math.max(minW, (track.clientWidth / track.scrollWidth) * 100);
        bar.style.width = w.toFixed(1) + '%';
        bar.style.left = ((x / max) * (100 - w)).toFixed(1) + '%';
      }
    }
    var raf = null;
    function onScroll() { if (!raf) raf = requestAnimationFrame(function () { updateUI(); raf = null; }); }
    track.addEventListener('scroll', onScroll, { passive: true, signal: signal });
    window.addEventListener('resize', onScroll, { passive: true, signal: signal });
    updateUI();
  }

  /* ---------- scroll parallax ---------- */
  function initParallax(root, signal) {
    if (root.getAttribute('data-cm-parallax') !== 'true') return;
    if (mobileMQ.matches || reduceMQ.matches) return;
    var targets = Array.prototype.slice.call(root.querySelectorAll('[data-cm-plx]'));
    if (!targets.length) return;
    var amp = parseFloat(root.getAttribute('data-cm-parallax-amp')) || 12;
    var raf = null;
    function apply() {
      var vh = window.innerHeight;
      targets.forEach(function (t) {
        var anchor = t.closest('[data-cm-plx-anchor]') || root;
        var r = anchor.getBoundingClientRect();
        if (r.bottom < -150 || r.top > vh + 150) return;
        var p = ((r.top + r.height / 2) - vh / 2) / (vh / 2 + r.height / 2);
        if (p > 1) p = 1; if (p < -1) p = -1;
        var f = parseFloat(t.getAttribute('data-cm-plx')) || 1;
        t.style.transform = 'translate3d(0,' + (p * amp * f).toFixed(1) + 'px,0)';
      });
      raf = null;
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(apply); }
    window.addEventListener('scroll', onScroll, { passive: true, signal: signal });
    window.addEventListener('resize', onScroll, { passive: true, signal: signal });
    requestAnimationFrame(apply);
  }

  /* ---------- pause infinite animations while offscreen ---------- */
  function initPause(root) {
    var targets = [];
    if (root.hasAttribute('data-cm-pause')) targets.push(root);
    root.querySelectorAll('[data-cm-pause]').forEach(function (t) { targets.push(t); });
    if (!targets.length || !('IntersectionObserver' in window)) return;
    targets.forEach(function (t) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { e.target.classList.toggle('cm-off', !e.isIntersecting); });
      }, { rootMargin: '120px 0px' });
      io.observe(t);
    });
  }

  /* ---------- deferred hover image (second product image) ---------- */
  function hydrateHoverImgs(card) {
    card.querySelectorAll('img[data-cm-src]').forEach(function (img) {
      if (img.getAttribute('data-cm-srcset')) { img.srcset = img.getAttribute('data-cm-srcset'); img.removeAttribute('data-cm-srcset'); }
      img.src = img.getAttribute('data-cm-src');
      img.removeAttribute('data-cm-src');
    });
  }
  function initHoverSrc(root, signal) {
    ['pointerover', 'focusin', 'touchstart'].forEach(function (evt) {
      root.addEventListener(evt, function (e) {
        var card = e.target.closest('[data-cm-hovercard]');
        if (card && card.querySelector('img[data-cm-src]')) hydrateHoverImgs(card);
      }, { passive: true, signal: signal });
    });
  }

  /* ---------- quick view ---------- */
  function initQuickview(root, signal) {
    var modal = root.querySelector('[data-cqv-modal]');
    if (!modal) return;
    var wrap = modal.querySelector('.cqv-mgrid');
    var dialog = modal.querySelector('.cqv-dialog');
    var money = moneyFactory(modal.getAttribute('data-money-format'));
    var rootUrl = (modal.getAttribute('data-root-url') || '/').replace(/\/$/, '');
    var cartAddUrl = modal.getAttribute('data-cart-add-url') || '/cart/add.js';
    var cartUrl = modal.getAttribute('data-cart-url') || '/cart';
    var T;
    try { T = JSON.parse(modal.getAttribute('data-i18n') || '{}'); } catch (err) { T = {}; }
    function t(k, fb) { return T[k] || fb; }
    var lastFocus = null;

    function focusables() {
      return Array.prototype.filter.call(
        dialog.querySelectorAll('button, [href], select, input, textarea, [tabindex]:not([tabindex="-1"])'),
        function (el) { return !el.disabled && el.offsetParent !== null; }
      );
    }
    function open() {
      lastFocus = document.activeElement;
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var x = modal.querySelector('.cqv-x');
      if (x) x.focus();
    }
    function close() {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.isConnected) lastFocus.focus();
    }
    modal.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', close, { signal: signal }); });
    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }, { signal: signal });

    function findVariant(p, sel) {
      return p.variants.find(function (v) {
        return (v.option1 || null) === (sel[0] || null) && (v.option2 || null) === (sel[1] || null) && (v.option3 || null) === (sel[2] || null);
      });
    }

    function render(p) {
      var img = p.featured_image || (p.images && p.images[0]) || '';
      var multi = p.variants.length > 1;
      var html = '';
      html += '<div class="cqv-mimg">' + (img ? '<img src="' + img + '" alt="' + esc(p.title) + '">' : '') + '</div>';
      html += '<div class="cqv-mbody">';
      html += '<h3 class="cqv-mtitle">' + esc(p.title) + '</h3>';
      html += '<div class="cqv-mprice"></div>';
      if (p.description) { html += '<div class="cqv-mdesc">' + p.description + '</div>'; }
      if (multi) {
        p.options.forEach(function (opt, i) {
          /* Shopify product.js may return options as strings (legacy) or objects {name,position,values} */
          var oname = (opt && typeof opt === 'object') ? opt.name : opt;
          var vals = [];
          p.variants.forEach(function (v) { var ov = v['option' + (i + 1)]; if (ov && vals.indexOf(ov) < 0) vals.push(ov); });
          html += '<div class="cqv-mopt"><label>' + esc(oname) + '</label><select data-opt="' + i + '">' +
            vals.map(function (x) { return '<option value="' + esc(x) + '">' + esc(x) + '</option>'; }).join('') + '</select></div>';
        });
      }
      html += '<button type="button" class="cqv-madd">' + esc(t('add', 'Add to cart')) + '</button>';
      html += '<a class="cqv-mlink" href="' + p.url + '">' + esc(t('details', 'View full details')) + ' &rarr;</a>';
      html += '</div>';
      wrap.innerHTML = html;

      var priceEl = wrap.querySelector('.cqv-mprice');
      var addBtn = wrap.querySelector('.cqv-madd');
      var selects = Array.prototype.slice.call(wrap.querySelectorAll('select[data-opt]'));

      function current() {
        if (!multi) return p.variants[0];
        var sel = [];
        selects.forEach(function (s) { sel[parseInt(s.getAttribute('data-opt'), 10)] = s.value; });
        return findVariant(p, sel);
      }
      function refresh() {
        var v = current();
        if (!v) { priceEl.textContent = t('unavailable', 'Unavailable'); addBtn.disabled = true; addBtn.textContent = t('unavailable', 'Unavailable'); return; }
        var ph = money(v.price);
        if (v.compare_at_price && v.compare_at_price > v.price) { ph += '<span class="mwas">' + money(v.compare_at_price) + '</span>'; }
        priceEl.innerHTML = ph;
        if (v.available) { addBtn.disabled = false; addBtn.textContent = t('add', 'Add to cart'); }
        else { addBtn.disabled = true; addBtn.textContent = t('soldout', 'Sold out'); }
        addBtn.setAttribute('data-vid', v.id);
      }
      selects.forEach(function (s) { s.addEventListener('change', refresh); });
      refresh();

      addBtn.addEventListener('click', function () {
        var vid = addBtn.getAttribute('data-vid');
        if (!vid || addBtn.disabled) return;
        addBtn.disabled = true;
        addBtn.textContent = t('adding', 'Adding...');
        fetch(cartAddUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] }) })
          .then(function (r) { if (!r.ok) throw 0; return r.json(); })
          .then(function () { window.location.href = cartUrl; })
          .catch(function () { addBtn.disabled = false; addBtn.textContent = t('retry', 'Try again'); });
      });
    }

    root.querySelectorAll('[data-cqv-open]').forEach(function (btn) {
      if (btn.tagName !== 'BUTTON') return; /* B2B "view product" links are anchors */
      btn.addEventListener('click', function () {
        var h = btn.getAttribute('data-handle');
        if (!h) return;
        wrap.innerHTML = '<div class="cqv-msg">' + esc(t('loading', 'Loading…')) + '</div>';
        open();
        fetch(rootUrl + '/products/' + h + '.js')
          .then(function (r) { return r.json(); })
          .then(render)
          .catch(function () { wrap.innerHTML = '<div class="cqv-msg">' + esc(t('error', 'Could not load product.')) + '</div>'; });
      }, { signal: signal });
    });
  }

  /* ---------- scope lifecycle ---------- */
  function initScope(root) {
    if (scopes.has(root)) return;
    var ac = new AbortController();
    scopes.set(root, ac);
    initReveal(root);
    initCarousel(root, ac.signal);
    initParallax(root, ac.signal);
    initPause(root);
    initHoverSrc(root, ac.signal);
    initQuickview(root, ac.signal);
  }
  function destroyScope(root) {
    var ac = scopes.get(root);
    if (ac) { ac.abort(); scopes.delete(root); }
  }
  function scan(container) {
    (container || document).querySelectorAll('[data-castello]').forEach(initScope);
  }

  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-castello]').forEach(destroyScope);
    if (e.target.matches && e.target.matches('[data-castello]')) destroyScope(e.target);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
})();
